"use strict";
var React = require('react')
var Link = require('react-router')
var ReactDOM = require('react-dom');
var Carousel = require('nuka-carousel');
var _ = require('underscore')
var ImageStore = require('../../store/ImageStore')
var galleryAction = require('../../actions/galleryAction');
var Loader = require('react-loader');
var DocMeta = require('react-doc-meta');
var SlikeGal = React.createClass({
 mixins: [Carousel.ControllerMixin],
 componentDidMount(){
    $('html, body').animate({
      scrollTop: $('.navbar').height()
    }, 800);
    ImageStore.addChangeListener(this.onChange);
    galleryAction.getImg(this.props.params.id);

    $('html, body').animate({
      scrollTop: $('.navbar').height()
    }, 800);
},

    componentWillUnmount() {
        ImageStore.removeChangeListener(this.onChange);
    },
    getInitialState() {
        var state = ImageStore.getImages();
        return state;
    },
    onChange() {
        var state = ImageStore.getImages();
        this.setState(state);
    },
 render() {
console.log(this.props)
        return (
            <Loader loaded={this.state.fetched}>
               <div className='col-margin-top-img row '>
                <Carousel className='text-center' slidesToShow={1} cellAlign="center" edgeEasing="easeOutCirc" slideWidth={1} cellSpacing={20} >
                    {this.imgList()}
                </Carousel>
                </div>
            </Loader>
        );
    },
    imgList(){
    var url = this.props.routes[0].path === "/" ? '../img/galerija/slike/' : '../../img/galerija/slike/'
      var listItems = _.map(this.state.data, function(pic, index){

        var src = url+pic.putanja
        return (
          <div key={index}>
            <img className='imgCarusel' src={src} />
            <p className="legend">{pic.opis}</p>
          </div>
        )
      })
      return(listItems);
    }
})

module.exports = SlikeGal;



/** WEBPACK FOOTER **
 ** ./modules/components/Galerija/SlikeGal.js
 **/